// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wooper_paldea: PokeData = {
  "id": 10253,
  "name": "wooper-paldea",
  "height": 4,
  "weight": 110,
  "base_experience": 42,
  "types": [
    PokeType.POISON,
    PokeType.GROUND
  ],
  "api_moves": [
    "slam",
    "tackle",
    "tail-whip",
    "earthquake",
    "toxic",
    "amnesia",
    "yawn",
    "mud-shot",
    "poison-tail",
    "toxic-spikes",
    "poison-jab",
    "sludge-wave"
  ],
  "moves": [
    "tackle",
    "earthquake",
    "mud-shot",
    "toxic-spikes",
    "poison-jab",
    "toxic-overload",
    "poison-fang",
    "mortal-gas",
    "earth-power",
    "stun-spore",
    "sludge-bomb",
    "bonemerang",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 96,
    "item": null,
    "species": [
      {
        "name": "wooper",
        "order": 225,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "quagsire",
        "order": 226,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "clodsire",
        "order": 1009,
        "types": [
          PokeType.POISON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 194,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 90,
    "speed": 30,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "paldea"
} as const;
